export const URL_SUPPORT =
  'https://support.fabfitfun.com/en/articles/44-how-can-i-contact-customer-care';
